import { FormHelperText, Stack } from '@mui/material';
import DateRangePickerInput from 'components/FormCreatorComponent/inputs/DateRangePickerInput';
import { TimePicklistInput } from 'components/TimePicklistInput';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { buildDateRangeField } from '../createForm.helpers';
import { CreateFormFieldLabel } from './CreateFormFieldLabel';

type CreateFormScheduleSectionProps = {
	dateRange: { startDate: Date; endDate: Date };
	onDateRangeChange: (value: { startDate: Date; endDate: Date }) => void;
	startTime: string;
	onStartTimeChange: (value: string) => void;
	endTime: string;
	onEndTimeChange: (value: string) => void;
	scheduleInvalid?: boolean;
};

export const CreateFormScheduleSection = ({
	dateRange,
	onDateRangeChange,
	startTime,
	onStartTimeChange,
	endTime,
	onEndTimeChange,
	scheduleInvalid = false,
}: CreateFormScheduleSectionProps) => {
	const t = useAppSelector(selectTranslations);

	return (
		<Stack spacing={0.75}>
			<CreateFormFieldLabel label={t('page.systemMessages.field.dateRange')} />
			<Stack spacing={2.5}>
				<DateRangePickerInput
					valid={true}
					cField={buildDateRangeField('', dateRange)}
					initialValidation={[]}
					sendSelectionToParent={onDateRangeChange}
				/>
				<Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
					<TimePicklistInput
						value={startTime}
						onChange={onStartTimeChange}
						label={t('page.systemMessages.field.fromTime')}
					/>
					<TimePicklistInput
						value={endTime}
						onChange={onEndTimeChange}
						label={t('page.systemMessages.field.toTime')}
					/>
				</Stack>
				{scheduleInvalid ? (
					<FormHelperText error>{t('page.systemMessages.field.dateRange.invalid')}</FormHelperText>
				) : null}
			</Stack>
		</Stack>
	);
};
